<template>
  <div class="daijinquan">
    <!-- <el-dialog
      :visible.sync="dialogVisible1"
      custom-class="daijinquan-box"
      :show-close="false"
    >
      <div class="voucher">
        <div class="voucher-title">
          <p>我的代金券（{{ VoucherList.length }}）</p>
        </div>
        <div class="voucher-content">
          <div
            class="voucher-item pointer"
            v-for="item in VoucherList"
            :key="item.voucherId"
            @click="voucherClick(item)"
          >
            <div class="voucher-item-t">
              <div class="voucher-item-t-l">
                <div>{{ item.amount }}</div>
                <p class="icon">元</p>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="2"
                height="60"
                viewBox="0 0 2 60"
                fill="none"
              >
                <path opacity="0.5" d="M1 0V60" stroke="#0062FF" stroke-dasharray="5 5" />
              </svg>
              <div class="voucher-item-t-r">
                <div>电子合同-代金券</div>
                <div v-if="item.voucherId === params.voucherId">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="15"
                      height="15"
                      rx="7.5"
                      stroke="#0062FF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="8"
                      height="8"
                      rx="4"
                      fill="url(#paint0_linear_1912_2531)"
                    />
                    <defs>
                      <linearGradient
                        id="paint0_linear_1912_2531"
                        x1="8"
                        y1="4"
                        x2="8"
                        y2="12"
                        gradientUnits="userSpaceOnUse"
                      >
                        <stop stop-color="#0062FF" />
                        <stop offset="1" stop-color="#003B99" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div v-else>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                  >
                    <rect
                      opacity="0.5"
                      x="0.5"
                      y="0.5"
                      width="13"
                      height="13"
                      rx="6.5"
                      stroke="#0062FF"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="voucher-item-c"></div>
            <div class="voucher-item-b">
              <div class="voucher-item-b-l">有效期至：</div>
              <div class="voucher-item-b-r">
                {{ item.validUntil | timeFormat("yyyy-mm-dd") }}
              </div>
            </div>
          </div>
        </div>
        <div class="voucher-footer">
          <div class="voucher-footer-btn" @click="voucherBtnClick">确认</div>
        </div>
      </div>
    </el-dialog> -->
    <el-dialog :visible.sync="dialogVisible1" :show-close="false" width="860px">
      <div class="box2">
        <div class="box2-title">
          <p>可用代金劵</p>
        </div>
        <div class="box2-content">
          <el-table :data="VoucherList" style="width: 100%" empty-text="暂无可用代金劵" @row-click="(row)=>voucherClick(row)">
            <el-table-column prop="amount" label="代金劵金额">
              <template slot-scope="scope">
                <span v-html="voucherAmountRender(scope.row)"></span>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="类型">
              <template slot-scope="scope">
                <div v-html="voucherTypeRender(scope.row)"></div>
              </template>
            </el-table-column>
            <el-table-column prop="validUntil" label="有效时间">
              <template slot-scope="scope">
                <div>
                  <div>起 - {{ scope.row.createdAt | timeFormat("yyyy-mm-dd") }}</div>
                  <div>止 - {{ scope.row.validUntil | timeFormat("yyyy-mm-dd") }}</div>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="state" label="状态">
              <template slot-scope="scope">
                <div v-html="voucherStateDataRender(scope.row)"></div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120">
              <template slot-scope="scope">
                <div class="setting" >
                  <img
                    style="width: 16px"
                    src="@/assets/image/home/select_y.webp"
                    alt=""
                    srcset=""
                    v-if="scope.row.voucherId === params.voucherId"
                  />
                  <img
                    style="width: 16px"
                    src="@/assets/image/home/select_n.png"
                    alt=""
                    srcset=""
                    v-else
                  />
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="box2-footer">
          <el-button size="mini" @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="voucherBtnClick" size="mini">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectData from "@/mixins/selectData";
export default {
  components: {},
  props: {
    VoucherList: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [selectData],
  data() {
    return {
      dialogVisible1: false,
      params: {
        voucherId: null,
      },
    };
  },
  created() {},
  computed: {},
  methods: {
    // 代金券点击
    voucherClick(item) {
      const { voucherId } = item;
      if (this.params.voucherId == voucherId) {
        this.params.voucherId = null;
      } else {
        this.params.voucherId = voucherId;
      }
    },
    voucherBtnClick() {
      const { voucherId } = this.params;
      if (!voucherId) {
        this.$emit("success", null);
        this.dialogVisible1 = false;

        return;
      }
      const item = this.VoucherList.find((res) => res.voucherId === voucherId);
      this.$emit("success", item);
      this.dialogVisible1 = false;
    },
    show() {
      this.dialogVisible1 = true;
    },
  },
};
</script>

<style scoped lang="scss">
.box2 {
  &-title {
    height: 60px;
    padding: 0 16px;
    display: flex;
    align-items: center;

    font-size: 18px;
    font-weight: 500;
    color: #262626;
  }

  &-content {
    // margin-top: 35px;
    height: 400px;
    overflow-y: auto;
    padding: 0 16px;
  }

  &-footer {
    height: 64px;
    padding: 0 16px;
    flex-shrink: 0;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
